import React, { useRef, useState, useEffect, useCallback } from 'react'
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';

import { Alert, Autocomplete, AvatarGroup, CardContent, CardMedia, Checkbox, CircularProgress, Container, Fade, FormControl, FormControlLabel, FormGroup, Grid, Icon, List, ListItem, ListItemAvatar, ListItemText, Zoom } from '@mui/material'
import Sidebar from '../../components/Sidebar';

import { AiOutlineClose } from "react-icons/ai";


// Importaciones para el modal
import { Button, Modal, Box, Typography, TextField, Tabs, Tab, Divider, Switch, Card, Avatar, IconButton, Chip } from '@mui/material';

import imageCompression from 'browser-image-compression';
// Iconos
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PublicIcon from '@mui/icons-material/Public';
import SearchIcon from '@mui/icons-material/Search';
import ImageIcon from '@mui/icons-material/Image';
import HttpsIcon from '@mui/icons-material/Https';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Tres puntos horizontales
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import CircleIcon from '@mui/icons-material/Circle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import ShareIcon from '@mui/icons-material/Share';

// Redux
import store from '../../store';
import { EVENTMODAL_action, GUESTSMODAL_action } from '../../store/actions/modalAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

// Date y time pickers
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es'; // Importa el idioma español
import { DesktopDatePicker, MobileTimePicker, StaticDateTimePicker, StaticTimePicker } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';


// Componentes de Material UI
import InputAdornment from '@mui/material/InputAdornment';

import ButtonBase from '@mui/material/ButtonBase';

import hamburguesa from '../../images/hamburguesa.jpg'

// Componentes de JOY UI
import { AspectRatio, Input, Textarea } from '@mui/joy';
import CateringCard from '../../components/Cards/CateringCard';
import Header from '../../components/Header';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import axios from 'axios';
import { connect } from 'react-redux';
import CryptoJS from "crypto-js";
import { FaShareAlt } from 'react-icons/fa';
import { LoadScript, GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import MapWithAutocomplete from '../../components/maps';
import { AdvancedMarker, APIProvider, Map, Pin } from '@vis.gl/react-google-maps';
import { CheckBox } from '@mui/icons-material';
import { Autocomplete as GoogleAutocomplete } from '@react-google-maps/api';

const mapStateToProps = (state) => {
    return {
        page: state.pageReducer.pageName,
        user: state.userReducer,
        eventModalState: state.modalReducer.eventModalState,
        guestsModalState: state.modalReducer.guestsModalState,
        token: state.tokenReducer.token
    }
}


const CreateEvent = (props) => {
    const autocompleteRef = useRef(null);
    let [publicKey, setPublicKey] = useState('');
    let statePublicKey = '';
    let [privateKey, setPrivateKey] = useState('');
    let statePrivatecKey = '';

    const [isLargeScreen, setIsLargeScreen] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [openModalAddGuests, setOpenModalAddGuests] = useState(false);
    const fileInputRef = useRef(null);
    const [eventCreadoID, setEventCreadoID] = useState('');
    let [tabValue, setTabValue] = useState(0);
    const [showExtraTab, setShowExtraTab] = useState(false);

    const [openShareModal, setOpenShareModal] = useState(false);
    const [showShareToast, setShowShareToast] = useState(false);
    const [eventLink, setEventLink] = useState('');

    // Función para manejar el cambio de pestañas
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // Efecto para manejar el tamaño de la pantalla
    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Estados para la información del evento
    const [eventName, setEventName] = useState('');
    const [eventDescription, setEventDescription] = useState('');
    const [eventImage, setEventImage] = useState('');
    const [eventImageBlob, setEventImageBlob] = useState('');
    const [eventLocation, setEventLocation] = useState('');
    const [detailedLocation, setDetailedLocation] = useState('');
    let [eventCoords, setEventCoords] = useState('');
    const [locationDetails, setLocationDetails] = useState({});
    const [inicialEventCoords, setInicialEventCoords] = useState('');
    const [avatar, setAvatar] = useState('');
    const [friends, setFriends] = useState([]);
    const [searchFriends, setSearchFriends] = useState('');



    const filteredFriends = friends.filter(friend =>
        friend.nameUser.toLowerCase().includes(searchFriends.toLowerCase())
    );



    // const [selectedDate, setSelectedDate] = useState('')
    const [selectedDate, setSelectedDate] = useState(null)

    const [valuee, setValuee] = React.useState(dayjs('2022-04-17'));
    const [traducedDate, setTraducedDate] = useState(null)

    const [selectedHour, setSelectedHour] = useState(null)
    const [traducedHour, setTraducedHour] = useState(null)

    let [eventTypeManual, setEventTypeManual] = useState('') // Tipo de Evento

    let [eventTypeAuto, setEventTypeAuto] = useState(null) // Tipo de Evento

    let [eventPrivacity, setEventPrivacity] = useState(false) // Tipo de Evento

    let [guests, setGuests] = useState([ // Aca se almacenaran los usuarios invitados
    ])

    let [selectedGuest, setSelectedGuest] = useState(null) // Aca se almacenaran los datos del usuario a invitar

    let [eventCaracteristics, setEventCaracteristics] = useState('')
    let [guardarEstadoEventCaracteristics, setGuardarEstadoEventCaracteristics] = useState("")
    const [guestsView, setGuestsView] = useState(false)

    const [eventCreator, setEventCreator] = useState('')

    // VARIABLES PARA TIPO DE PRIVACIDAD
    const [indexEventPrivacity, setIndexEventPrivacity] = useState(0)

    const [showAlert, setShowAlert] = useState(false)
    let [typeAlert, setTypeAlert] = useState('')
    let [alertMsg, setAlertMsg] = useState('')


    let [locationValid, setLocationValid] = useState(true)
    const [checked, setChecked] = React.useState(true);


    // LISTADO DE USUARIOS DISPONIBLES PARA INVITAR AL EVENTO A CREAR
    const [availableUsers, setAvailableUsers] = useState([]);

    const eventTypes = [
        { type: 'No definido', keywords: ['indefinido', 'otro', 'sin definir'] },
        { type: 'Cumpleaños', keywords: ['cumple', 'aniversario', 'birthday', 'festejo'] },
        { type: 'Reunión Laboral Virtual', keywords: ['trabajo', 'meet', 'zoom', 'online', 'virtual', 'laboral'] },
        { type: 'Reunión Laboral Presencial', keywords: ['trabajo', 'oficina', 'presencial', 'laboral'] },
        { type: 'Casamiento', keywords: ['boda', 'matrimonio', 'wedding', 'civil'] },
        { type: 'Viaje', keywords: ['excursión', 'tour', 'paseo', 'vacaciones', 'viaje'] },
        { type: 'Juntada común', keywords: ['reunión', 'reunion', 'mateada', 'amigos', 'social', 'encuentro'] },
        { type: 'Club Nocturno', keywords: ['fiesta', 'boliche', 'disco', 'baile', 'noche'] },
        { type: 'Fiesta Nacional', keywords: ['patria', 'celebración', 'conmemoración'] },
        { type: 'Funcion Teatral', keywords: ['teatro', 'obra', 'espectáculo', 'show'] },
        { type: 'Show musical', keywords: ['concierto', 'recital', 'música', 'banda'] },
        { type: 'Evento al aire libre', keywords: ['outdoor', 'parque', 'plaza', 'picnic', 'exterior'] },
        { type: 'Evento Virtual', keywords: ['online', 'digital', 'remoto', 'internet', 'virtual'] },
    ];

    // Función para filtrar eventos basado en palabras clave
    const filterEventTypes = (searchText) => {
        if (!searchText) return eventTypes.map(event => event.type);

        const searchLower = searchText.toLowerCase();
        return eventTypes
            .filter(event =>
                event.type.toLowerCase().includes(searchLower) ||
                event.keywords.some(keyword => keyword.toLowerCase().includes(searchLower))
            )
            .map(event => event.type);
    };


    // VARIABLES PARA HABILITAR DISTINTAS CARACTERISTICAS DEL EVENTO
    let [enableGuests, setEnableGuests] = useState(false) // Su valor cambia al seleccionar Publico o Privado
    let [mode, setMode] = useState(false);

    // let [selectedUser, setSelectedUser] = useState()


    // FUNCIONES ----------------------------------------------------------------
    function changeCreationMode(params) {

    }

    async function generateUniqueSlug() {
        // Crear un array de 8 bytes aleatorios
        const array = new Uint8Array(8);
        // Usar la API Web Crypto para generar números aleatorios criptográficamente seguros
        window.crypto.getRandomValues(array);
        // Convertir a base64url
        return btoa(String.fromCharCode.apply(null, array))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    // FUNCION PARA CREAR EL EVENTO FINALMENTE
    async function CreateNewEvent() {


        // Verifica que la ubicacion ingresada sea valida
        // console.log("entra");
        // console.log(eventLocation);
        // if (locationValid == true) {

        //     try {
        //         var location = JSON.parse(eventLocation)
        //         const geocoder = new window.google.maps.Geocoder();
        //         geocoder.geocode({ location: location }, (results, status) => {
        //             if (status === "OK") {
        //                 if (results[0]) {
        //                     console.log("Dirección encontrada:", results[0].formatted_address);
        //                     setLocationValid(true);
        //                 } else {
        //                     console.log("No se encontraron resultados.");
        //                     setLocationValid(false);
        //                 }
        //             } else {
        //                 console.error("Fallo en la geocodificación inversa: " + status);
        //                 setLocationValid(false);
        //             }
        //         });

        //     } catch (error) {
        //         console.error("Error: " + error);
        //         setLocationValid(false);
        //     }

        // } else {

        //     setLocationValid(true);
        //     console.log("locationValid");
        //     console.log(locationValid);
        // }



        // VALIDACION DATOS OBLIGATORIOS
        if (eventName == '') {
            let errores = ''
            setShowAlert(true)
            setTypeAlert('error')

            if (eventName == '') {
                errores += ' | Nombre del evento '
            }
            setAlertMsg(errores)

        } else {


            let eventType = ''
            let privacity = ''
            if (eventPrivacity === true) {
                privacity = 'PRIVADO'
            } else {
                privacity = 'PUBLICO'
            }

            if (eventTypeAuto !== null) {
                eventType = eventTypeAuto
            } else {
                eventType = eventTypeManual
            }


            try {
                setLoading(true); // Mostrar pantalla de carga
                // const formData = new FormData();
                // formData.append('file', eventImage);

                let compressedFile;
                var imageUrl = "";
                // let formData = new FormData();

                if (eventImageBlob) {

                    const options = {
                        maxSizeMB: 1, // Tamaño máximo en MB
                        maxWidthOrHeight: 1024, // Resolución máxima
                        useWebWorker: true, // Usar Web Worker para mejor rendimiento
                        fileType: 'image/webp', // Convertir a WebP
                    };

                    try {
                        compressedFile = await imageCompression(eventImageBlob, options);
                        imageUrl = await uploadImageToBackend(compressedFile);
                        // formData.append('file', compressedFile);
                    } catch (error) {
                        console.error('Error comprimiendo la imagen:', error);
                    }
                }


                let guestsTraduccion = ""
                // console.log(guests)
                friends.map((item, index) => {
                    if (item.selected == true) {
                        guestsTraduccion += item.userID + "; "
                    }
                })


                const headers = 'content-type: application/json; charset=utf-8'
                const token = localStorage.getItem('jwt_token');


                var userData = JSON.parse(localStorage.getItem('userData'))

                console.log("eventCoords")
                console.log(eventCoords)
                if (typeof eventCoords !== 'string') {
                    eventCoords = JSON.stringify(eventCoords)
                }

                let slug = ''
                slug = await generateUniqueSlug()

                const data = {
                    "eventType": (eventType == '' ? 'No definido' : eventType),
                    "creatorAvatar": JSON.parse(localStorage.getItem('userData')).avatar,
                    "eventTitle": eventName,
                    "creatorId": JSON.parse(localStorage.getItem('userData')).userID,
                    "guestsId": guestsTraduccion,
                    "creatorName": props.user.nombre,
                    "eventDescription": eventDescription,
                    "startDay": selectedDate,
                    "startHour": traducedHour,
                    "eventLocation": eventLocation || detailedLocation,
                    "eventLocationCoords": typeof eventCoords === 'string' ? eventCoords : JSON.stringify(eventCoords),
                    "eventPrivacity": privacity,
                    "eventImage": imageUrl,
                    "eventCharacteristics": eventCaracteristics,
                    "slug": slug
                }

                console.log("data")
                console.log(data)

                // const jsonData = JSON.stringify(data);
                // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

                // await axios.put('https://socializeapi.azurewebsites.net/api/CreateEvent', data, {
                //     headers
                // })
                //     .then(response => {
                //         // enviarnotificacionCreatedEvent(data)

                //         setEventName('')
                //         setEventDescription('')
                //         setEventLocation('')
                //         setSelectedDate('')
                //     })
                //     .catch(error => {
                //         console.log(`Error obteniendo datos: ${error}`);
                //         if (error == "AxiosError: Request failed with status code 401") {
                //             navigate("/login")
                //             alert("Sesión caducada!")
                //         }
                //     });


                // store.dispatch(CREATE_EVENT_action({name: eventName, description: eventDescription, image: eventImage}))


            } catch (error) {
                console.log(`Error obteniendo datos: ${error}`);
            } finally {
                setLoading(false); // Ocultar pantalla de carga
                // await obtenerDatosEventoCreado()
                // if (privacity == "PRIVADO") {
                //     console.log("entro")
                //     // setOpenModalAddGuests(true);
                //     setOpenShareModal(true);
                // } else {
                //     console.log("entro2")
                //     // setOpenModalAddGuests(false);
                //     // setShowShareToast(true);
                //     navigate('/');
                // }
            }




        }
    }

    async function getAvatar() {
        const data = {
            "UserID": props.user.id,
        }
        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'

        await axios.post('https://socializeapi.azurewebsites.net/api/GetAvatar', { data: data_encripted }, {
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            responseType: 'blob'
        })
            .then(response => {
                const imageUrl = URL.createObjectURL(response.data);

                console.log("imageUrl")
                console.log(imageUrl)
                setAvatar(imageUrl)
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }

    const uploadImageToBackend = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch('https://socializeapi.azurewebsites.net/api/upload', {
            method: 'POST',
            body: formData,
        });

        console.log("uploadImageToBackend")
        console.log(response)

        if (response.ok) {
            const data = await response.json(); // Obtener la URL de la respuesta
            console.log('Imagen subida con éxito. URL:', data.url);
            return data.url; // Retornar la URL para asociarla al evento
        } else {
            console.error('Error subiendo la imagen');
            throw new Error('Error al subir la imagen')
        }
    };




    async function enviarnotificacionCreatedEvent(eventData) {
        let guestsTraduccion = ""
        // console.log(guests)
        friends.map((item, index) => {
            if (item.selected == true) {
                guestsTraduccion += item.userID + "; "
            }
        })

        const headers = 'content-type: application/json; charset=utf-8'
        await obtenerVAPID()

        const data = {
            "privateKey": statePrivatecKey,
            "publicKey": statePublicKey,
            "userAgent": navigator.userAgent,
            "invitedUsers": guestsTraduccion,
            "eventData": eventData,
            "action": "createevent"
        }

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



        await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
            headers
        })
            .then(response => {
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error == "AxiosError: Request failed with status code 401") {
                    navigate("/login")
                    alert("Sesión caducada!")
                }
            });
    }


    async function obtenerVAPID() {
        const headers = 'content-type: application/json; charset=utf-8'

        await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
            .then(response => {
                if (response.data !== null) {
                    setPublicKey(response.data.value.keys.publicKey)
                    statePublicKey = response.data.value.keys.publicKey
                    setPrivateKey(response.data.value.keys.privateKey)
                    statePrivatecKey = response.data.value.keys.privateKey
                }

            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }

    const AddGuests = (event, value) => {
        // if (value !== undefined) {
        //     const newArray = guests.map((item) => {
        //         return {...item}
        //     })

        //     newArray.push(value)
        //     setGuests(newArray)
        // }
        let existe = false

        if (value !== undefined) {
            const newArray = guests.map((item) => {
                if (item.userID == value.userID) {
                    existe = true
                }
                return { ...item }
            })

            if (existe === false) {
                newArray.push(value)
            }

            setGuests(newArray)
        }
    }
    const DeleteGuests = (item) => {

        // const newArray = guests.map((guest, index) => {

        //     if (guest.id === item.id) {
        //         guests.splice(index, 1)

        //         return {...guest}
        //     }
        // })

        let newArray = []
        guests.map((guest, index) => {
            if (guest.UserID !== item.UserID) {
                newArray.push(guest)
            }
        })

        setGuests(newArray)
    }

    // Agregar estilos globales al scrollbar
    const customScrollbarStyles = `
::-webkit-scrollbar {
  width: 10px;
}


::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`;

    // FUNCION PARA CAMBIAR LA PRIVACIDAD DEL EVENTO
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const changeEventPrivacity = (event, newValue) => {
        setIndexEventPrivacity(newValue);
    };


    // FUNCION PARA TRADUCIR LA FECHA DEL EVENTO
    // const traduceSelectedDate = (date) => {
    //     console.log(selectedDate)
    //     if(!isNaN(date.target.value)) {
    //         // if (selectedDate.length == 2 || selectedDate.length == 5) {
    //         //     setSelectedDate(selectedDate + '/'+date.target.value);
    //         // }
    //         setSelectedDate(date.target.value);
    //     } else {
    //         setSelectedDate('');
    //     }
    // }


    // FUNCION PARA TRADUCIR LA HORA DEL EVENTO
    const traduceSelectedHour = (time) => {

        setSelectedHour(time)
        const fecha = new Date(time);
        const options = { hour: '2-digit', minute: '2-digit', hour12: false };
        const fechaEnEspanol = fecha.toLocaleDateString('es-ES', options);

        let fecha2 = fechaEnEspanol;
        fecha2 = fecha2.replace(/^[^,]*,\s*/g, '');
        setTraducedHour(fecha2);
    }

    const handleGetLocationFromChild = (location) => {
        console.log("Entra al padre");
        console.log("Ubicación obtenida:", location);
        const parts = location.split("|");
        const source = parts[0]; // "Auto" o "Manual"

        if (source === "Auto") {
            // Formato: "Auto|dirección|coordenadas"
            const address = parts[1];
            const coords = JSON.parse(parts[2]);

            console.log("Coordenadas:", coords);
            console.log("Dirección obtenida por geocodificación:", address);
            console.log(address);

            setEventCoords(coords);
            setInicialEventCoords(coords);

            // Si el input está vacío, usamos la dirección obtenida por geocodificación
            // Esto ocurre cuando el usuario arrastra el mapa
            setEventLocation(address);

            setLocationValid(true);
        } else if (source === "Manual") {
            // Formato: "Manual|dirección" o "Manual|dirección|coordenadas"
            const inputValue = parts[1];

            if (inputValue === "" || inputValue === undefined) {
                // Input vacío
                setLocationValid(true);
            } else {
                // Usamos el valor exacto del input para eventLocation
                setEventLocation(inputValue);

                // Si hay coordenadas disponibles (cuando se selecciona un lugar del autocomplete)
                if (parts.length > 2) {
                    const coords = JSON.parse(parts[2]);
                    setEventCoords(coords);
                    setInicialEventCoords(coords);
                }

                setLocationValid(true);
            }
        }
    };

    const onChangeLocation = (location) => {
        // console.log(location)
        // setEventLocation(location)
        console.log("2 paso")
        console.log(location)
        setEventCoords(location)
    };


    const [file, setFile] = useState()

    const handleImageUpload = (e) => {
        setFile(e.target.files[0])
        // Guardar el archivo en el estado local o realizar otras operaciones
    };

    const [value, setValue] = useState(null);

    const handleOnChange = (event, newValue) => {
        // console.log(newValue)
        setValue(newValue);
    };

    const getOptionLabel = (option) => {
        if (typeof option === 'string') {
            return option;
        }
        if (option instanceof String) {
            return option.toString();
        }
        return option.label;
    };

    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    const handleCheckboxChange = (index) => {
        setFriends(prevFriends => {
            const updatedFriends = [...prevFriends];
            updatedFriends[index].selected = !updatedFriends[index].selected;
            return updatedFriends;
        });
    };

    // EFFECTS

    useEffect(() => {
        if (!props.token) {
            console.log("el token no es valido")
            navigate("/")
        } else {
            // const map = new window.google.maps.Map(mapRef.current, {
            //     center: { lat: -34.397, lng: 150.644 },
            //     zoom: 8,
            // });
            setSelectedDate(null)
            getFriends();
            getAvatar();
            // const token = localStorage.getItem('jwt_token');

            // var data = {
            //     loguedUser: props.user.id
            // }

            // const jsonData = JSON.stringify(data);
            // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

            // // const headers = 'content-type: application/json; charset=utf-8'
            // axios.post(`https://socializeapi.azurewebsites.net/api/GetUsers`, { data: data_encripted }, {
            //     withCredentials: true,
            //     headers: {
            //         Authorization: `Bearer ${token}`, // Añadir el token en el encabezado
            //     },
            // })
            //     .then(response => {
            //         let decripted_response = decryptData(response.data)
            //         let convertedToArray = JSON.parse(decripted_response)

            //         setAvailableUsers(convertedToArray)
            //     })
            //     .catch(error => {
            //         console.log(`Error obteniendo datos: ${error}`);
            //         if (error == "AxiosError: Request failed with status code 401") {
            //             navigate("/login")
            //             alert("Sesión caducada!")
            //         }
            //     })
        }
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    async function getFriends() {
        const token = localStorage.getItem('jwt_token');

        var data = {
            userID_1: props.user.id
        }

        // const jsonData = JSON.stringify(data);
        // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'
        console.log("getFriends")
        await axios.post(`https://socializeapi.azurewebsites.net/api/getfriends`, data, {
            headers
        })
            .then(response => {

                const friendsWithSelected = response.data.map(friend => {
                    return {
                        ...friend,
                        selected: false // Puedes establecer el valor inicial que desees, en este caso 'false'
                    };
                });

                setFriends(friendsWithSelected)
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error == "AxiosError: Request failed with status code 401") {
                    navigate("/login")
                    alert("Sesión caducada!")
                }
            })
    }

    const uploadImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Realizar la conversión de la imagen al formato necesario (base64)
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setEventImage(base64String)
                // Enviar la imagen al endpoint a través de una petición a SQL
                // Aquí se realizaría la lógica para enviar la imagen en formato base64 a la base de datos
            };
            setEventImageBlob(file)
            reader.readAsDataURL(file);
        }
    };


    const cambiarModo = () => {
        setMode(!mode);
        if (mode) {
            setEventTypeManual('');
            setEventTypeAuto(null)

            setEventDescription(eventCaracteristics)
            setEventCaracteristics(guardarEstadoEventCaracteristics)
        } else {
            setGuardarEstadoEventCaracteristics(eventCaracteristics)
            // setGuardarEstadoEventDescription(eventDescription)

            setEventCaracteristics(eventDescription)
            setEventDescription('')
        }
    };

    async function obtenerDatosEventoCreado() {

        const data = {
            "eventID": -1,
        }

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();


        const token = localStorage.getItem('jwt_token');
        const headers = 'content-type: application/json; charset=utf-8'
        await axios.post(`https://socializeapi.azurewebsites.net/api/GetEvent`, { data: data_encripted }, {
            headers
        })
            .then(response => {
                let decripted_response = decryptData(response.data)

                // Convertir el string a un objeto
                const responseObject = JSON.parse(decripted_response);

                console.log("responseObject.EventID")
                console.log(responseObject.EventID)
                const encrypted = CryptoJS.AES.encrypt(responseObject.EventID.toString(), "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

                setEventCreadoID(encrypted);
                setEventLink(`https://hisocialize.netlify.app/event/${responseObject.Slug}`)

            })
            .catch(error => {
                console.log(`Error obteniendo los eventos: ${error}`);
            })
    }

    const handleShare = async () => {
        console.log("eventCreadoID")
        console.log(eventCreadoID)
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Invitación',
                    text: 'Únete al evento en nuestra página',
                    url: `https://hisocialize.netlify.app/registro?data=${encodeURIComponent(eventCreadoID)}`,
                });
                console.log('Compartido con éxito');
            } catch (error) {
                console.error('Error al compartir:', error);
            }
        } else {
            alert('La función de compartir no está disponible en este dispositivo.');
        }
    };

    // Estilos en línea como objetos de JavaScript
    const styles = {
        loadingScreen: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        loadingModal: {
            backgroundColor: 'white',
            padding: '20px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
        },
        loadingSpinner: {
            margin: '20px auto',
            width: '40px',
            height: '40px',
            border: '4px solid transparent',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
        },
        '@keyframes spin': {
            from: {
                transform: 'rotate(0deg)',
            },
            to: {
                transform: 'rotate(360deg)',
            },
        },
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4, mt: isLargeScreen && 2 }}>
            {isLargeScreen && <Header></Header>}
            {isLargeScreen && <Sidebar></Sidebar>}




            {isLargeScreen && (
                <Box sx={{ width: '100%', typography: 'body1', marginBottom: 8 }}>
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        mb: 3,
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'background.paper',
                        zIndex: 1000,
                        padding: '10px 0',
                        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="event creation tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Información Básica" />
                            <Tab label="Ubicación" />
                            {eventPrivacity && <Tab label="Invitados" />}
                            <Tab label="Importante" />
                            {(eventTypeManual && eventTypeManual !== "No definido") && <Tab label="Extra" />}
                        </Tabs>
                    </Box>

                    {/* Panel de Información Básica */}
                    {tabValue === 0 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Información del Evento
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 3,
                                        }}
                                    >
                                        <Fade in={true} timeout={800}>
                                            <Card
                                                elevation={eventImage ? 3 : 0}
                                                sx={{
                                                    width: '100%',
                                                    height: isLargeScreen ? 300 : 200,
                                                    borderRadius: 4,
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    transition: 'all 0.8s ease-in-out', // Increased transition duration
                                                    bgcolor: eventImage ? 'background.paper' : 'grey.50',
                                                    '&:hover': {
                                                        transform: 'scale(1.01)',
                                                        boxShadow: eventImage ? 6 : 0
                                                    }
                                                }}
                                            >
                                                {eventImage ? (
                                                    <CardMedia
                                                        component="img"
                                                        image={eventImage}
                                                        alt="Event preview"
                                                        sx={{
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            transition: 'all 0.8s ease-in-out'
                                                        }}
                                                    />


                                                ) : (
                                                    <Box
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: 2
                                                        }}
                                                    >
                                                        <ImageIcon
                                                            sx={{
                                                                fontSize: 60,
                                                                color: 'grey.400',
                                                                opacity: 0.8
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body1"
                                                            color="text.secondary"
                                                            sx={{
                                                                fontStyle: 'italic',
                                                                opacity: 0.8
                                                            }}
                                                        >
                                                            Agregale una imagen a tu evento (opcional)
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 16,
                                                        right: 16,
                                                        display: 'flex',
                                                        gap: 1
                                                    }}
                                                >
                                                    <Zoom in={true} timeout={500}>
                                                        <IconButton
                                                            component="label"
                                                            sx={{
                                                                bgcolor: 'primary.main',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    bgcolor: 'primary.dark',
                                                                    transform: 'scale(1.1)'
                                                                },
                                                                transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                            }}
                                                        >
                                                            <CameraAltIcon />
                                                            <input
                                                                type="file"
                                                                hidden
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                onChange={(event) => uploadImage(event)}
                                                            />
                                                        </IconButton>
                                                    </Zoom>

                                                    {eventImage && (
                                                        <Zoom in={true} timeout={500}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEventImage('');
                                                                    setEventImageBlob('');
                                                                    fileInputRef.current.value = '';
                                                                }}
                                                                sx={{
                                                                    bgcolor: 'error.main',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        bgcolor: 'error.dark',
                                                                        transform: 'scale(1.1)'
                                                                    },
                                                                    transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Zoom>
                                                    )}
                                                </Box>
                                            </Card>
                                        </Fade>

                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Nombre del Evento"
                                        value={eventName}
                                        onChange={(e) => setEventName(e.target.value)}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        label="Descripción"
                                        multiline
                                        rows={4}
                                        value={eventDescription}
                                        onChange={(e) => setEventDescription(e.target.value)}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Card sx={{ mb: 2 }}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Fecha y Hora
                                            </Typography>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', sm: 'row' },
                                                gap: 2,
                                                width: '100%'
                                            }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                    <DatePicker
                                                        label="Fecha del Evento"
                                                        value={selectedDate}
                                                        onChange={(newValue) => setSelectedDate(newValue)}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiInputBase-root': {
                                                                width: '100%'
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <MobileTimePicker
                                                        label="Hora del Evento"
                                                        value={selectedHour}
                                                        onChange={(event) => { traduceSelectedHour(event) }}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiInputBase-root': {
                                                                width: '100%'
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* Tipo de evento */}

                                {/* <Grid item xs={12}>
                                <Card>
                                    <CardContent sx={{
                                        height: '124px', // Initial fixed height
                                        transition: 'height 0.3s ease',
                                        overflow: 'hidden',
                                        '&:focus-within': {
                                            height: '250px' // Expanded height when TextField is focused
                                        }
                                    }}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Tipo de Evento
                                        </Typography>
                                        <FormControl fullWidth>
                                            <TextField
                                                fullWidth
                                                size='small'
                                                label="Buscar tipo de evento"
                                                value={eventTypeManual}
                                                onChange={(e) => setEventTypeManual(e.target.value)}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: eventTypeManual && (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setEventTypeManual('')}
                                                                edge="end"
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </FormControl>
                                        <Box
                                            sx={{
                                                mt: 2,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: 1
                                            }}
                                        >
                                            {filterEventTypes(eventTypeManual)
                                                .map((type, index) => (
                                                    <Button
                                                        key={index}
                                                        variant={eventTypeManual === type ? "contained" : "outlined"}
                                                        size="small"
                                                        onClick={() => setEventTypeManual(type)}
                                                        sx={{
                                                            borderRadius: '5px',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                        {type}
                                                    </Button>
                                                ))
                                            }
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}
                                <Grid item xs={12}>
                                    <Card elevation={0}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Privacidad
                                            </Typography>
                                            <Box sx={{
                                                mt: 2,
                                                p: 3,
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                cursor: 'pointer',
                                            }}
                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}>
                                                {/* TIPO DE PRIVACIDAD */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    mb: 3
                                                }}>

                                                    {/* <Typography
                                                    fontSize={14}
                                                    sx={{
                                                        color: eventPrivacity ? '#ff5b5b' : '#20cca5',
                                                        mb: 2,
                                                        textAlign: 'center',
                                                        maxWidth: '80%',
                                                        fontStyle: 'italic'
                                                    }}
                                                >
                                                    {eventPrivacity
                                                        ? "(Privado: Solo usted y los usuarios que invite podrán ver este Evento)."
                                                        : "(Público: Todos los que entren HiSocialize verán este Evento)."}
                                                </Typography> */}
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    mt: 3
                                                }}>
                                                    {eventPrivacity ? (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#ffe0b2',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#ffcc80'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <HttpsIcon sx={{ color: '#ff9100', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'#ff9100'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Privado
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#838fcf',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#6573c3'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <PublicIcon sx={{ color: '#3f51b5', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'primary'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Público
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {/* Panel de Ubicación */}
                    <Box display={tabValue === 1 ? 'block' : 'none'}>
                        <Typography variant="h6" gutterBottom>
                            Ubicación del Evento
                        </Typography>
                        <Card elevation={0}>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <MapWithAutocomplete
                                            onLocationSelect={({ address, coordinates }) => {
                                                setEventLocation(address);
                                                setDetailedLocation(address);
                                                setEventCoords(coordinates);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>

                    {/* Panel de Invitados */}
                    {(tabValue === 2 && eventPrivacity == true) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Gestión de Invitados
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="info" sx={{ mb: 2 }}>
                                                No te preocupes si no encuentras a alguien en tu lista de amigos. Después de crear el evento, podrás compartir el enlace de invitación con cualquier persona.
                                            </Alert>
                                            <TextField
                                                fullWidth
                                                label="Buscar Amigos"
                                                value={searchFriends}
                                                onChange={(e) => setSearchFriends(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                                {filteredFriends.map((friend, index) => (
                                                    <ListItem
                                                        key={index}
                                                        secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => {
                                                                    const updatedFriends = friends.map(f => {
                                                                        if (f.userID === friend.userID) {
                                                                            return { ...f, selected: !f.selected };
                                                                        }
                                                                        return f;
                                                                    });
                                                                    setFriends(updatedFriends);
                                                                }}
                                                                checked={friend.selected || false}
                                                            />
                                                        }
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar src={`${friend.avatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`} />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={friend.nameUser}
                                                            secondary={friend.email}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Características */}
                    {((tabValue === 3 && eventPrivacity === true) || (tabValue === 2 && eventPrivacity === false)) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Información importante del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Extras */}
                    {((tabValue === 4 && eventPrivacity === true && (eventTypeManual && eventTypeManual !== "No definido")) || (tabValue === 3 && eventPrivacity === false && (eventTypeManual && eventTypeManual !== "No definido"))) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Caracteristicas extras del evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Botones de Acción */}
                    <Box sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        bottom: 20,
                        left: 0,
                        right: 0,
                        width: '100%',
                        maxWidth: '100%',
                        zIndex: 1000,
                        px: { xs: 2, sm: 4 }, // Responsive padding
                        mx: 'auto', // Center the box
                        boxSizing: 'border-box', // Include padding in width calculation
                        gap: 2 // Add spacing between buttons
                    }}>

                        <Button
                            variant="outlined"
                            onClick={() => navigate('/')}
                            startIcon={<KeyboardArrowLeftIcon />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 2,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '120px',
                                color: 'grey.700',
                                borderColor: 'grey.400',
                                '&:hover': {
                                    bgcolor: 'grey.100',
                                    borderColor: 'grey.500',
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={CreateNewEvent}
                            // disabled={loading || !eventName || !selectedDate || !traducedHour}
                            disabled={loading || !eventName}
                            startIcon={loading ? <CircularProgress size={24} /> : <EventAvailableIcon sx={{ fontSize: 28 }} />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 3,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '160px',
                                '&:hover': {
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            {loading ? 'Creando Evento...' : 'Crear Evento'}
                        </Button>
                    </Box>

                    {/* Alerta de Errores */}
                    {showAlert && (
                        typeAlert === 'error' ? (

                            <Alert
                                severity="error"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                Por favor, complete los siguientes campos:{alertMsg}
                            </Alert>
                        ) : (

                            <Alert
                                severity="info"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                {eventPrivacity ? "Solo tú y los usuarios que invites podrán ver este evento" : "Todos los que entren HiSocialize verán este Evento"}
                            </Alert>
                        )

                    )}
                </Box>

            )}

            {!isLargeScreen && (
                <Box sx={{ width: '100%', typography: 'body1', marginBottom: 8 }}>
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        mb: 3,
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'background.paper',
                        zIndex: 1000,
                        padding: '10px 0',
                        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="event creation tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Información Básica" />
                            <Tab label="Ubicación" />
                            {eventPrivacity && <Tab label="Invitados" />}
                            <Tab label="Importante" />
                            {(eventTypeManual && eventTypeManual !== "No definido") && <Tab label="Extra" />}
                        </Tabs>
                    </Box>

                    {/* Panel de Información Básica */}
                    {tabValue === 0 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Información del Evento
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 3,
                                        }}
                                    >
                                        <Fade in={true} timeout={800}>
                                            <Card
                                                elevation={eventImage ? 3 : 0}
                                                sx={{
                                                    width: '100%',
                                                    height: isLargeScreen ? 300 : 200,
                                                    borderRadius: 4,
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    transition: 'all 0.8s ease-in-out', // Increased transition duration
                                                    bgcolor: eventImage ? 'background.paper' : 'grey.50',
                                                    '&:hover': {
                                                        transform: 'scale(1.01)',
                                                        boxShadow: eventImage ? 6 : 0
                                                    }
                                                }}
                                            >
                                                {eventImage ? (
                                                    <CardMedia
                                                        component="img"
                                                        image={eventImage}
                                                        alt="Event preview"
                                                        sx={{
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            transition: 'all 0.8s ease-in-out'
                                                        }}
                                                    />
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: 2
                                                        }}
                                                    >
                                                        <ImageIcon
                                                            sx={{
                                                                fontSize: 60,
                                                                color: 'grey.400',
                                                                opacity: 0.8
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body1"
                                                            color="text.secondary"
                                                            sx={{
                                                                fontStyle: 'italic',
                                                                opacity: 0.8
                                                            }}
                                                        >
                                                            Agregale una imagen a tu evento (opcional)
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 16,
                                                        right: 16,
                                                        display: 'flex',
                                                        gap: 1
                                                    }}
                                                >
                                                    <Zoom in={true} timeout={500}>
                                                        <IconButton
                                                            component="label"
                                                            sx={{
                                                                bgcolor: 'primary.main',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    bgcolor: 'primary.dark',
                                                                    transform: 'scale(1.1)'
                                                                },
                                                                transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                            }}
                                                        >
                                                            <CameraAltIcon />
                                                            <input
                                                                type="file"
                                                                hidden
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                onChange={(event) => uploadImage(event)}
                                                            />
                                                        </IconButton>
                                                    </Zoom>

                                                    {eventImage && (
                                                        <Zoom in={true} timeout={500}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEventImage('');
                                                                    setEventImageBlob('');
                                                                    fileInputRef.current.value = '';
                                                                }}
                                                                sx={{
                                                                    bgcolor: 'error.main',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        bgcolor: 'error.dark',
                                                                        transform: 'scale(1.1)'
                                                                    },
                                                                    transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Zoom>
                                                    )}
                                                </Box>
                                            </Card>
                                        </Fade>

                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Nombre del Evento"
                                        value={eventName}
                                        onChange={(e) => setEventName(e.target.value)}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        label="Descripción"
                                        multiline
                                        rows={4}
                                        value={eventDescription}
                                        onChange={(e) => setEventDescription(e.target.value)}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" sx={{ ml: 2 }}>
                                        Fecha y Hora
                                    </Typography>

                                    <Card elevation={0}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                    <DatePicker
                                                        label="Fecha del Evento"
                                                        value={selectedDate}
                                                        onChange={(newValue) => setSelectedDate(newValue)}
                                                        renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <MobileTimePicker
                                                        label="Hora del Evento"
                                                        value={selectedHour} onChange={(event) => { traduceSelectedHour(event) }}
                                                        renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* Tipo de evento */}

                                {/* <Grid item xs={12}>
                            <Card>
                                <CardContent sx={{
                                    height: '124px', // Initial fixed height
                                    transition: 'height 0.3s ease',
                                    overflow: 'hidden',
                                    '&:focus-within': {
                                        height: '250px' // Expanded height when TextField is focused
                                    }
                                }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Tipo de Evento
                                    </Typography>
                                    <FormControl fullWidth>
                                        <TextField
                                            fullWidth
                                            size='small'
                                            label="Buscar tipo de evento"
                                            value={eventTypeManual}
                                            onChange={(e) => setEventTypeManual(e.target.value)}
                                            margin="normal"
                                            InputProps={{
                                                endAdornment: eventTypeManual && (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setEventTypeManual('')}
                                                            edge="end"
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                    <Box
                                        sx={{
                                            mt: 2,
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1
                                        }}
                                    >
                                        {filterEventTypes(eventTypeManual)
                                            .map((type, index) => (
                                                <Button
                                                    key={index}
                                                    variant={eventTypeManual === type ? "contained" : "outlined"}
                                                    size="small"
                                                    onClick={() => setEventTypeManual(type)}
                                                    sx={{
                                                        borderRadius: '5px',
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    {type}
                                                </Button>
                                            ))
                                        }
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid> */}
                                <Grid item xs={12}>
                                    <Card elevation={0}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Privacidad
                                            </Typography>
                                            <Box sx={{
                                                mt: 2,
                                                p: 3,
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'

                                            }}
                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}>
                                                {/* TIPO DE PRIVACIDAD */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    mb: 3
                                                }}>

                                                    {/* <Typography
                                                fontSize={14}
                                                sx={{
                                                    color: eventPrivacity ? '#ff5b5b' : '#20cca5',
                                                    mb: 2,
                                                    textAlign: 'center',
                                                    maxWidth: '80%',
                                                    fontStyle: 'italic'
                                                }}
                                            >
                                                {eventPrivacity
                                                    ? "(Privado: Solo usted y los usuarios que invite podrán ver este Evento)."
                                                    : "(Público: Todos los que entren HiSocialize verán este Evento)."}
                                            </Typography> */}
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    mt: 3
                                                }}>
                                                    {eventPrivacity ? (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#ffe0b2',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#ffcc80'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <HttpsIcon sx={{ color: '#ff9100', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'#ff9100'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Privado
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#838fcf',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#6573c3'
                                                                    }
                                                                }}

                                                            >
                                                                <PublicIcon sx={{ color: '#3f51b5', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'primary'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Público
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {/* Panel de Ubicación */}
                        <Box display={tabValue === 1 ? 'block' : 'none'}>
                            <Typography variant="h6" gutterBottom>
                                Ubicación del Evento
                            </Typography>
                            <Card elevation={0}>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <MapWithAutocomplete
                                                onLocationSelect={({ address, coordinates }) => {
                                                    setEventLocation(address);
                                                    setEventCoords(coordinates);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>

                    {/* Panel de Invitados */}
                    {(tabValue === 2 && eventPrivacity == true) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Gestión de Invitados
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="info" sx={{ mb: 2 }}>
                                                No te preocupes si no encuentras a alguien en tu lista de amigos. Después de crear el evento, podrás compartir el enlace de invitación con cualquier persona.
                                            </Alert>
                                            <TextField
                                                fullWidth
                                                label="Buscar Amigos"
                                                value={searchFriends}
                                                onChange={(e) => setSearchFriends(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                                {filteredFriends.map((friend, index) => (
                                                    <ListItem
                                                        key={index}
                                                        secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => {
                                                                    const updatedFriends = friends.map(f => {
                                                                        if (f.userID === friend.userID) {
                                                                            return { ...f, selected: !f.selected };
                                                                        }
                                                                        return f;
                                                                    });
                                                                    setFriends(updatedFriends);
                                                                }}
                                                                checked={friend.selected || false}
                                                            />
                                                        }
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar src={friend.avatar} />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={friend.nameUser}
                                                            secondary={friend.email}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Características */}
                    {((tabValue === 3 && eventPrivacity === true) || (tabValue === 2 && eventPrivacity === false)) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Información importante del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Extras */}
                    {((tabValue === 4 && eventPrivacity === true && (eventTypeManual && eventTypeManual !== "No definido")) || (tabValue === 3 && eventPrivacity === false && (eventTypeManual && eventTypeManual !== "No definido"))) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Caracteristicas extras del evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Botones de Acción */}
                    <Box sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        bottom: 20,
                        left: 0,
                        right: 0,
                        width: '100%',
                        maxWidth: '100%',
                        zIndex: 1000,
                        px: { xs: 2, sm: 4 }, // Responsive padding
                        mx: 'auto', // Center the box
                        boxSizing: 'border-box', // Include padding in width calculation
                        gap: 2 // Add spacing between buttons
                    }}>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/')}
                            startIcon={<KeyboardArrowLeftIcon />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 2,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '120px',
                                color: 'grey.700',
                                borderColor: 'grey.400',
                                '&:hover': {
                                    bgcolor: 'grey.100',
                                    borderColor: 'grey.500',
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={CreateNewEvent}
                            // disabled={loading || !eventName || !selectedDate || !traducedHour}
                            disabled={loading || !eventName}
                            startIcon={loading ? <CircularProgress size={20} /> : <EventAvailableIcon />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 3,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '160px',
                            }}
                        >
                            {loading ? 'Creando Evento...' : 'Crear Evento'}
                        </Button>
                    </Box>

                    {/* Alerta de Errores */}
                    {showAlert && (
                        typeAlert === 'error' ? (

                            <Alert
                                severity="error"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                Por favor, complete los siguientes campos:{alertMsg}
                            </Alert>
                        ) : (

                            <Alert
                                severity="info"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                {eventPrivacity ? "Solo tú y los usuarios que invites podrán ver este evento" : "Todos los que entren HiSocialize verán este Evento"}
                            </Alert>
                        )

                    )}
                </Box>
            )}


            <Modal
                open={openShareModal}
                onClose={() => { setOpenShareModal(false); navigate('/'); }}
                aria-labelledby="share-modal-title"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            ¡Evento creado exitosamente!
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={() => { setOpenShareModal(false); navigate('/') }}
                            sx={{ ml: 2 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Puedes invitar a más personas compartiendo este enlace:
                    </Typography>
                    <TextField
                        fullWidth
                        value={eventLink}
                        variant="outlined"
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => navigator.clipboard.writeText(eventLink)}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                        <Button
                            startIcon={<WhatsAppIcon />}
                            variant="contained"
                            color="success"
                            onClick={() => window.open(`whatsapp://send?text=${encodeURIComponent(`¡Te invito a mi evento! ${eventLink}`)}`)}
                        >
                            WhatsApp
                        </Button>
                        <Button
                            startIcon={<EmailIcon />}
                            variant="contained"
                            color="primary"
                            onClick={() => window.open(`mailto:?subject=Invitación a evento&body=${encodeURIComponent(`¡Te invito a mi evento! ${eventLink}`)}`)}
                        >
                            Email
                        </Button>
                        <Button
                            startIcon={<ShareIcon />}
                            variant="contained"
                            onClick={() => navigator.share({
                                title: 'Invitación a evento',
                                text: '¡Te invito a mi evento!',
                                url: eventLink
                            })}
                        >
                            Compartir
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Container>
    );


}

export default connect(mapStateToProps)(CreateEvent)


// Este es un formato de ejemplo. Borra o agregar lo que quieras
